import React from 'react';
import Form from '../../../../components/molecules/Form';

import PageMoveFormTemplate from './PageMoveFormTemplate';
import FormActionShape from '../../../../lib/shapes/FormActionShape';

function PageMoveForm({ form }) {
  return (
    <Form id="page-move-form" model={form}>
      <PageMoveFormTemplate />
    </Form>
  );
}

PageMoveForm.propTypes = {
  form: FormActionShape.isRequired,
};

export default PageMoveForm;
